import { Injectable, Type } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ExportStockDrawerComponent } from '../../shared/export-stock-drawer/export-stock-drawer.component';
import { EditStockDrawerComponent } from '../../pages/stock/components/edit-stock-drawer/edit-stock-drawer.component';
import { EditStockDrawerData } from '../../pages/stock/interfaces/stock-edit.interface';
import { AddStockDrawerComponent, AddStockDrawerData } from '../../pages/stock/components/add-stock-drawer/add-stock-drawer.component';
import { StoreStockAndLot, StoreStockLot } from 'src/app/pages/stock/interfaces/stock.interface';

export interface DrawerConfig {
    component: Type<any>;
    data?: any;
    width?: string;
}

@Injectable({
    providedIn: 'root'
})
export class DrawerService {
    private isOpenSubject = new BehaviorSubject<boolean>(false);
    private configSubject = new BehaviorSubject<DrawerConfig | null>(null);
    private closedSubject = new Subject<any>();

    private openTimeout: any = null;
    private closeTimeout: any = null;

    private drawerVersion = 0;

    isOpen$ = this.isOpenSubject.asObservable();
    config$ = this.configSubject.asObservable();
    onClose$ = this.closedSubject.asObservable();

    openDrawer(config: DrawerConfig): void {
        if (this.openTimeout) {
            clearTimeout(this.openTimeout);
            this.openTimeout = null;
        }
        if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
            this.closeTimeout = null;
        }

        if (this.isOpenSubject.getValue()) {
            this.closeDrawer();
        }

        this.openTimeout = setTimeout(() => {
            this.drawerVersion++;
            const currentVersion = this.drawerVersion;
            this.configSubject.next(config);
            this.isOpenSubject.next(true);
            this.openTimeout = null;
        }, 100);
    }

    closeDrawer(data?: any): void {
        if (this.openTimeout) {
            clearTimeout(this.openTimeout);
            this.openTimeout = null;
        }

        if (data !== undefined) {
            this.closedSubject.next(data);
        }
        this.isOpenSubject.next(false);

        if (this.closeTimeout) {
            clearTimeout(this.closeTimeout);
        }
        this.drawerVersion++;
        const currentVersion = this.drawerVersion;
        this.closeTimeout = setTimeout(() => {
            if (this.drawerVersion === currentVersion) {
                this.configSubject.next(null);
            }
            this.closeTimeout = null;
        }, 300);
    }

    openExportStockDrawer(data?: any): void {
        this.openDrawer({
            component: ExportStockDrawerComponent,
            width: 'min(500px, 90vw)',
            data: {
                titleKey: 'pages.stock.export.title',
                ...data
            }
        });
    }

    openEditStockDrawer(data: StoreStockAndLot): void {
        this.openDrawer({
            component: EditStockDrawerComponent,
            data: data
        });
    }

    openAddStockDrawer(data: AddStockDrawerData): any {
        return this.openDrawer({
            component: AddStockDrawerComponent,
            width: 'min(500px, 90vw)',
            data: {
                ...data,
                titleKey: 'pages.stock.add_stock.drawer_title'
            }
        });
    }


}
